export default __webpack_public_path__ + "static/media/sp-imone-boy.b3be92f5.webp";